import { atom, useAtom } from "jotai";
import { useEffect } from "react";
import { ActivityType, ChatResponse } from "../../components/Deepchat/models";
import { QuestionTargetSalesData } from "../../components/Deepchat/state/DeepchatState";
import useDeepchat from "../../contexts/useDeepchat";

//ATOMS
export const historyLoadingAtom = atom(true);
export const historyAtom = atom<ChatResponse[][]>([]);
// Bumped whenever the recent-threads list needs to be refetched (e.g. after a new
// thread is created) so newly created threads appear without a page refresh.
export const historyRefreshAtom = atom(0);

export const useRecentThreads = () => {
  const Deepchat = useDeepchat();
  const [historyLoading, setHistoryLoading] = useAtom(historyLoadingAtom);
  const [history, setHistory] = useAtom(historyAtom);
  const [historyRefresh] = useAtom(historyRefreshAtom);

  const [checkboxSalesData] = useAtom(QuestionTargetSalesData);

  const activity_type: ActivityType | undefined = checkboxSalesData ? "structured_data" : "deepchat";

  useEffect(
    () => {
      Deepchat.getHistory(activity_type)
        .then((_history) => {
          setHistoryLoading(false);
          setHistory(_history);
        })
        .catch((e) => {
          setHistory([]);
        })
        .finally(() => {
          setHistoryLoading(false);
        });
    },
    // Refresh when the parent view type changes, or when a new thread is created.
    [activity_type, historyRefresh],
  );

  return {
    historyLoading,
    history,
    activity_type,
  };
};
